import React from 'react';

export default function UndoBanner({
  message,
  onUndo,
  undoLabel = 'Undo',
  fixed = false,
  className = '',
}) {
  return (
    <div className={`undo-banner ${fixed ? 'undo-banner-fixed' : ''} ${className}`.trim()}>
      <span className="undo-banner-message">{message}</span>
      <button type="button" className="btn-subtle undo-banner-action" onClick={onUndo}>
        {undoLabel}
      </button>
    </div>
  );
}
